import { Component, ViewEncapsulation } from '@angular/core';
import { TrackingGridComponent } from './components/tracking-grid/tracking-grid.component';

@Component({
    selector: 'app-tracking',
    templateUrl: './tracking.component.html',
    styleUrls: ['./tracking.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [TrackingGridComponent]
})
export class TrackingComponent {}
